import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  useTheme,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId3 = [
  'no19',
  'no20',
  'no21',
  'no22',
  'no23',
  'no24',
  'no25',
  'no26',
  'no27',
  'no28',
  'no29',
  'no30',
  'no31',
  'no32',
];

const 영역3 = [
  {
    id: 1,
    ko: '19. 산소요법(O2therapy) 유지',
    info: ['산소농도조절, 환자반응 평가가 포함된다.'],
    desc: ['해당 없음', '1점'],
  },
  {
    id: 2,
    ko: '20. 산소요법(O2therapy) 시작 및 교환',
    info: [
      '기구를 준비하여(nasal prong, mask 등) 적용하거나, 교환하는 경우 해당된다',
    ],
    desc: ['해당 없음', '1점 : 저유량', '2점 : 고유량'],
  },
  {
    id: 3,
    ko: `21. 일산화질소(NO therapy) 또는\n        Heliox 요법 유지`,
    info: [
      'NO나 Heliox 중 1가지 요법을 적용하며, 가스농도 모니터, 환자의 부작용 관찰, 누출예방관리가 포함되며, 기록이 있어야 한다.',
    ],
    desc: ['해당 없음', '2점'],
  },
  {
    id: 4,
    ko: `22. 일산화질소(NO therapy) 또는 \n        Heliox 요법 시작 및 교환`,
    info: [
      'NO나 Heliox 장비 및 기구를 준비하여 적용을 시작하거나, 교환하는 경우 해당된다.',
    ],
    desc: ['해당 없음', '6점'],
  },
  {
    id: 5,
    ko: `23. 호흡운동(기침, 심호흡, incentive\n        spirometer 등) 6회 이상`,
    info: [
      '기구를 준비하고 사용 중 환자를 돕고 적절히 사용하도록 교육시행 및 기록이 포함된다. 6회 미만 시행한 경우와 환자 스스로 시행한 경우는 인정하지 않는다.',
    ],
    desc: ['해당 없음', '3점: 6회 이상'],
  },
  {
    id: 6,
    ko: '24. 흉부물리요법',
    info: [
      '청진 후 손상된 폐부위에 타진, vibration, postural drainage 등을 체계적으로 시행하고 환자의 상태를 평가 및 기록하는 일련의 모든 과정이 포함되어야 한다.',
    ],
    desc: ['해당 없음', '3점 : 2~3회', '6점 : 4~5회', '9점 : 6회 이상'],
  },
  {
    id: 7,
    ko: '25. 네블라이저 적용',
    info: [
      '간호사에 의해 직접 시행한 경우로 기구(drug nebulizer, ventilator nebulizer 등)를 준비하고 환자의 자세를 돕고 적절한 호흡법을 교육하며 치료를 시행하는 것이',
      '포함된다. IPPB 시행을 보조하는 경우도 포함된다.',
    ],
    desc: ['해당 없음', '3점 : 2~3회', '6점 : 4~5회', '9점 : 6회 이상'],
  },
  {
    id: 8,
    ko: '26. 기도 흡인간호',
    info: [
      'oro-tracheal, naso-tracheal, endotracheal suction을 포함한다.',
      '영아에게 oral bulb syringe suctioning하는 것도 포함된다.',
    ],
    desc: [
      '해당 없음',
      '4점 : 6~10회',
      '8점 : 11~20회',
      '10점 : 21~25회',
      '15점 : 30분마다',
    ],
  },
  {
    id: 9,
    ko: '27. 인공호흡기 유지',
    info: [
      '산소조절, 회로의 유지, 가습기의 유지, 환자 반응, alarm에 대한 조정을 포함한다.',
    ],
    desc: ['해당 없음', '15점'],
  },
  {
    id: 10,
    ko: '28. 인공호흡기 셋팅 및 적용',
    info: [
      '인공호흡기를 준비하여 새로 장착하거나, 인공호흡기 회로를 교환하는 경우에 해당된다. ',
    ],
    desc: ['해당 없음', '3점'],
  },
  {
    id: 11,
    ko: '29. 복위치료법',
    info: [
      '돌려 눕힐 때마다 횟수로 인정된다.',
      '환자를 돌려 눕히고 자세를 보조하며 반응을 살피는 것이 포함된다.',
    ],
    desc: ['해당 없음 ', '1회당 6점 :'],
  },
  {
    id: 12,
    ko: '30. 기관내관 삽관(intubation)',
    info: [
      '기관삽관을 위한 준비, 수행, 정리, 환자상태 관찰, 간호기록 등을 포함한다. ',
    ],
    desc: ['해당 없음', '4점'],
  },
  {
    id: 13,
    ko: '31. 기관내관 발관(extubation)',
    info: [
      '기관내관 발관을 위한 준비, 수행, 정리, 환자상태 관찰, 간호기록 등을 포함한다. Unplanned extubation은 포함하지 않는다.',
    ],
    desc: ['해당 없음', '2점'],
  },
  {
    id: 14,
    ko: '32. 인공기도(기관내관) 간호',
    info: [
      'endotracheal tube의 위치를 변경하는 경우나 T-cannula를 교환하는 경우에만 해당된다.',
    ],
    desc: ['해당 없음', '2점'],
  },
];

const radioId4 = ['no33', 'no34', 'no35', 'no36', 'no37'];

const 영역4 = [
  {
    id: 1,
    ko: '33. 체위변경',
    info: [
      '직원 2인 이상이 한조가 되어 환자의 체위를 변경하는 경우에만 해당된다.',
    ],
    desc: ['해당 없음', '6점 : 5~8회', '15점 : 9회 이상'],
  },
  {
    id: 2,
    ko: '34. ROM 시행 3회 이상',
    info: [' 직원이 직접 운동시킨 경우 해당된다.'],
    desc: ['해당 없음', '5점 : 3회 이상'],
  },
  {
    id: 3,
    ko: '35. 재활운동 -1',
    info: [
      '환자의 재활을 위하여 직원이 환자에게 standing, 침대 걸터 앉기, CPM적용 등을 시행하는 경우 해당된다.',
    ],
    desc: ['해당 없음 ', '1회당 3점 :'],
  },
  {
    id: 4,
    ko: '36. 재활운동 -2',
    info: [
      '환자의 재활을 위하여 직원이 환자에게 walker나 wheelchair ambu lation을 직접 시행한 경우 해당된다.',
    ],
    desc: ['해당 없음  ', '1회당 5점 :'],
  },
  {
    id: 5,
    ko: '37. 억제대 2부위 이상 적용',
    info: ['2부위 이상 사지 억제를 하고 말초순환을 확인할 때 해당된다.'],
    desc: ['해당 없음', '3점'],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  sum3: number;
  setSum3: (sum3: number) => void;

  prostate: number;
  setProstate: (prostate: number) => void;

  sum4: number;
  setSum4: (sum4: number) => void;

  exercise1: number;
  setExercise1: (exercise1: number) => void;

  exercise2: number;
  setExercise2: (exercise1: number) => void;
}
const KPCSCContents2 = (props: Props) => {
  const { palette } = useTheme();

  const {
    disabled,
    setValue,
    getValues,
    register,
    setSum3,
    setProstate,
    setSum4,
    setExercise1,
    setExercise2,
  } = props;

  const calculateSumValue3 = () => {
    setSum3(
      radioId3.reduce((acc, cur) => {
        if (cur === 'no29' && Number(getValues(cur)) > 0) {
          const value = Number(getValues(cur));
          return value ? acc + value - 1 : acc;
        }
        // 21, 31, 32번
        else if (cur === 'no21' || cur === 'no31' || cur === 'no32') {
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        }
        // 23, 24, 25, 28번
        else if (
          cur === 'no23' ||
          cur === 'no24' ||
          cur === 'no25' ||
          cur === 'no28'
        ) {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        }
        // 22번
        else if (cur === 'no22') {
          const value = Number(getValues(cur)) * 6;
          return value ? acc + value : acc;
        }
        // 26번
        else if (cur === 'no26') {
          if (Number(getValues(cur)) < 3) {
            const value = Number(getValues(cur)) * 4;
            return value ? acc + value : acc;
          } else if (Number(getValues(cur)) === 3) {
            const value = Number(getValues(cur)) * 3 + 1;
            return value ? acc + value : acc;
          } else if (Number(getValues(cur)) === 4) {
            const value = Number(getValues(cur)) * 4 - 1;
            return value ? acc + value : acc;
          }
        }
        // 27번
        else if (cur === 'no27') {
          const value = Number(getValues(cur)) * 15;
          return value ? acc + value : acc;
        }
        // 30번
        else if (cur === 'no30') {
          const value = Number(getValues(cur)) * 4;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const [disableProstate, setDisableProstate] = useState(false);

  const handleChange3 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue3();
  };

  const handleChange3Prostate_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no29_1', 0);
    setProstate(0);
    setDisableProstate(true);
    calculateSumValue3();
  };

  const handleChange3Prostate_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no29_1', 1);
    setProstate(6);
    setDisableProstate(false);
    calculateSumValue3();
  };

  const calculateSumValue4 = () => {
    setSum4(
      radioId4.reduce((acc, cur) => {
        if (
          (cur === 'no35' && Number(getValues(cur)) > 0) ||
          (cur === 'no36' && Number(getValues(cur)) > 0)
        ) {
          const value = Number(getValues(cur));
          return value ? acc + value - 1 : acc;
        }
        // 33번
        else if (cur === 'no33') {
          if (Number(getValues(cur)) === 2) {
            const value = Number(getValues(cur)) * 7 + 1;
            return value ? acc + value : acc;
          }
          const value = Number(getValues(cur)) * 6;
          return value ? acc + value : acc;
        }
        // 34번
        else if (cur === 'no34') {
          const value = Number(getValues(cur)) * 5;
          return value ? acc + value : acc;
        }
        // 37번
        else if (cur === 'no37') {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        }

        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange4 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue4();
  };

  const [disableExercise1, setDisableExercise1] = useState(false);
  const [disableExercise2, setDisableExercise2] = useState(false);

  const handleChange4Exercise1_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no35_1', 0);
    setExercise1(0);
    setDisableExercise1(true);
    calculateSumValue4();
  };

  const handleChange4Exercise1_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no35_1', 1);
    setExercise1(3);
    setDisableExercise1(false);
    calculateSumValue4();
  };

  const handleChange4Exercise2_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no36_1', 0);
    setExercise2(0);
    setDisableExercise2(true);
    calculateSumValue4();
  };

  const handleChange4Exercise2_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no36_1', 1);
    setExercise2(5);
    setDisableExercise2(false);
    calculateSumValue4();
  };

  useEffect(() => {
    calculateSumValue3();
    calculateSumValue4();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 호흡간호" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '30px' }}>
          <TableBody>
            {영역3.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역3.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역3.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '43px' : '28px',
                      }}
                      name={radioId3[content.id - 1]}
                      defaultValue={Number(getValues(radioId3[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no29'}
                                  value={i}
                                  onChange={handleChange3Prostate_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 6점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no29'}
                                  value={i}
                                  onChange={handleChange3Prostate_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId3[content.id - 1]}
                                  value={i}
                                  onChange={handleChange3}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역3.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '21px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          if (
                            item.includes(
                              'IPPB 시행을 보조하는 경우도 포함된다'
                            )
                          ) {
                            return (
                              <TableRow
                                sx={{
                                  lineHeight: '17px',
                                  height: '4px',
                                }}
                              >
                                <Box
                                  sx={{
                                    minWidth: '65vw',
                                    marginLeft: '-14px',
                                  }}
                                >
                                  {item}
                                </Box>
                              </TableRow>
                            );
                          }
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '17px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: '65vw',
                                  marginLeft: '-28px',
                                  whiteSpace: 'pre',
                                }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: '65vw',
                                  marginLeft: '-28px',
                                }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '1회당 6점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disableProstate ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no29_1', {
                                    onChange: e => {
                                      setValue(
                                        'no29_1',
                                        Number(e.target.value)
                                      );
                                      setProstate(
                                        Math.floor(getValues('no29_1') * 6)
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        }
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 기동성" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '-30px' }}>
          <TableBody>
            {영역4.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역4.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역4.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '43px' : '28px',
                      }}
                      name={radioId4[content.id - 1]}
                      defaultValue={Number(getValues(radioId4[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no35'}
                                  value={i}
                                  onChange={handleChange4Exercise1_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no35'}
                                  value={i}
                                  onChange={handleChange4Exercise1_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음  ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no36'}
                                  value={i}
                                  onChange={handleChange4Exercise2_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 5점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no36'}
                                  value={i}
                                  onChange={handleChange4Exercise2_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId4[content.id - 1]}
                                  value={i}
                                  onChange={handleChange4}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역4.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '1회당 3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disableExercise1 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no35_1', {
                                    onChange: e => {
                                      setValue(
                                        'no35_1',
                                        Number(e.target.value)
                                      );
                                      setExercise1(
                                        Math.floor(getValues('no35_1') * 3)
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 5점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disableExercise2 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no36_1', {
                                    onChange: e => {
                                      setValue(
                                        'no36_1',
                                        Number(e.target.value)
                                      );
                                      setExercise2(
                                        Math.floor(getValues('no36_1') * 5)
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        }
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCContents2;
